import { render, staticRenderFns } from "./EditStockist.vue?vue&type=template&id=936dd822&"
import script from "./EditStockist.vue?vue&type=script&lang=js&"
export * from "./EditStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports